import ActionsForm from '@/shared/mixins/actionsForm'
import qmaTemplate from '@/shared/http/repositories/business/qmaTemplate'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'deleteTemplate',
  props: ['id', 'template'],

  mixins: [ActionsForm],
  components: {},
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    popUptExlusao () {
      this.$refs['excluir-template'].show()
    },
    fecharPopUptDelete () {
      this.$refs['excluir-template'].hide()
    },
    deleteTemplateWeb () {
      loading.push()
      qmaTemplate.excluirTemplate(this.id)
        .then((Response) => {
          loading.pop()
          this.$emit('recarregarTable', true)
          this.fecharPopUptDelete()
        })
        .catch(Error => {
          loading.pop()
          toast.warning('Dados incorretos, falha ao cadastrar')
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/deleteTemplate/deleteTemplate.js